//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import pluginExport from '@d2-projects/vue-table-export';
Vue.use(pluginExport);
export default {
  data: function data() {
    return {
      table: {
        columns: [{
          label: 'ID',
          prop: 'id'
        }, {
          label: '名称',
          prop: 'name'
        }, {
          label: '创建日期',
          prop: 'creatDate'
        }, {
          label: '地址',
          prop: 'address'
        }, {
          label: '邮编',
          prop: 'zip'
        }],
        data: [{
          id: 1,
          name: 'Lucy',
          creatDate: '2020-05-07',
          address: 'Address',
          zip: '000000'
        }],
        size: 'mini',
        stripe: true,
        border: true
      }
    };
  },
  methods: {
    exportCsv: function exportCsv() {
      var _this = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$export.csv({
        columns: this.table.columns,
        data: this.table.data
      }).then(function () {
        _this.$message('导出CSV成功');
      });
    },
    exportExcel: function exportExcel() {
      var _this2 = this;

      this.$export.excel({
        columns: this.table.columns,
        data: this.table.data,
        header: '导出 Excel',
        merges: ['A1', 'E1']
      }).then(function () {
        _this2.$message('导出表格成功');
      });
    }
  }
};